// Super-admin router — ADR-007.

import type { JSX } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLoginPage } from "./pages/AdminLoginPage.js";
import { TenantListPage } from "./pages/TenantListPage.js";
import { TenantConfigPage } from "./pages/TenantConfigPage.js";
import { TemplatesPage } from "./pages/TemplatesPage.js";
import { AdminUsersPage } from "./pages/AdminUsersPage.js";
import { AdminAuditLogsPage } from "./pages/AdminAuditLogsPage.js";
import { ValidationRangesPage } from "./pages/ValidationRangesPage.js";
import { TotpSetupPage } from "./pages/TotpSetupPage.js";
import { SecuritySettingsPage } from "./pages/SecuritySettingsPage.js";
import { RequireAdminAuth } from "./components/RequireAdminAuth.js";

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login"                                element={<AdminLoginPage />} />
      <Route path="/setup-totp"                           element={<TotpSetupPage />} />
      <Route path="/"                                     element={<RequireAdminAuth><TenantListPage /></RequireAdminAuth>} />
      <Route path="/tenants"                              element={<Navigate to="/" replace />} />
      <Route path="/tenants/:tenantId"                    element={<RequireAdminAuth><TenantConfigPage /></RequireAdminAuth>} />
      <Route path="/tenants/:id/validation-ranges"        element={<RequireAdminAuth><ValidationRangesPage /></RequireAdminAuth>} />
      <Route path="/templates"                            element={<RequireAdminAuth><TemplatesPage /></RequireAdminAuth>} />
      <Route path="/users"                                element={<RequireAdminAuth><AdminUsersPage /></RequireAdminAuth>} />
      <Route path="/audit-logs"                           element={<RequireAdminAuth><AdminAuditLogsPage /></RequireAdminAuth>} />
      <Route path="/settings/security"                    element={<RequireAdminAuth><SecuritySettingsPage /></RequireAdminAuth>} />
      <Route path="*"                                     element={<Navigate to="/" replace />} />
    </Routes>
  );
}
